/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usage_Level_PendingInputs */

const en_usage_level_pending = /** @type {(inputs: Usage_Level_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pending`)
};

const zh_hans1_usage_level_pending = /** @type {(inputs: Usage_Level_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`处理中`)
};

const pt_br2_usage_level_pending = /** @type {(inputs: Usage_Level_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendente`)
};

const es_usage_level_pending = /** @type {(inputs: Usage_Level_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pendiente`)
};

const fr_usage_level_pending = /** @type {(inputs: Usage_Level_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En attente`)
};

const de_usage_level_pending = /** @type {(inputs: Usage_Level_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ausstehend`)
};

const ru_usage_level_pending = /** @type {(inputs: Usage_Level_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ожидает`)
};

const it_usage_level_pending = /** @type {(inputs: Usage_Level_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`In sospeso`)
};

/**
* | output |
* | --- |
* | "Pending" |
*
* @param {Usage_Level_PendingInputs} inputs
* @param {{ locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }} options
* @returns {LocalizedString}
*/
export const usage_level_pending = /** @type {((inputs?: Usage_Level_PendingInputs, options?: { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usage_Level_PendingInputs, { locale?: "en" | "zh-Hans" | "pt-BR" | "es" | "fr" | "de" | "ru" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "zh-Hans") return zh_hans1_usage_level_pending(inputs)
	if (locale === "pt-BR") return pt_br2_usage_level_pending(inputs)
	if (locale === "es") return es_usage_level_pending(inputs)
	if (locale === "fr") return fr_usage_level_pending(inputs)
	if (locale === "de") return de_usage_level_pending(inputs)
	if (locale === "ru") return ru_usage_level_pending(inputs)
	if (locale === "it") return it_usage_level_pending(inputs)
	return en_usage_level_pending(inputs)
});